import { useTranslation } from 'react-i18next'
import { PainQuestion, questions } from '@dentalux/ui-library-core/custom/components/pain-details-form'

const usePainDetailsQuestions = (): PainQuestion[] => {
  const { t } = useTranslation()

  return questions.map(
    (question): PainQuestion => ({
      ...question,
      label: t(question.label),
      answers: question.answers.map((answer) => ({ ...answer, label: t(answer.label) })),
    })
  )
}

export default usePainDetailsQuestions
